// Estado do formulário da forma de pagamento e conversão para o servidor.
// O ícone saiu (v1.5.784): nenhuma tela usava de verdade — o painel desenha o
// ícone pelo código da forma. Formas antigas continuam com o valor gravado.
import { ClipboardList, MessageCircle, QrCode, Smartphone } from "lucide-react";

import { CaixaRegistradoraIcon, MesaIcon, MotoEntregaIcon, TotemIcon } from "@/components/icons/ModulosIcons";

// Módulos em que a forma aparece, na ordem da tela: salão, caixa, entrega e
// online. Totem e Mesa QR têm chave própria desde 26/10/2026 (antes seguiam o
// Balcão e as Mesas). `key` = sufixo da coluna visible_<key> no servidor.
export const MODULOS = [
  { key: "mesas", label: "Mesas", curto: "Mesas", Icone: MesaIcon, ajuda: "Fechar mesa pelo garçom ou pelo caixa" },
  { key: "mesaqr", label: "Mesa QR Code", curto: "Mesa QR", Icone: QrCode, ajuda: "O cliente paga pelo QR Code da mesa" },
  { key: "comandas", label: "Comandas", curto: "Comandas", Icone: ClipboardList, ajuda: "Fechar comanda" },
  { key: "balcao", label: "Balcão", curto: "Balcão", Icone: CaixaRegistradoraIcon, ajuda: "Venda rápida no caixa" },
  { key: "totem", label: "Totem", curto: "Totem", Icone: TotemIcon, ajuda: "Autoatendimento: o cliente paga sozinho" },
  { key: "delivery", label: "Delivery", curto: "Delivery", Icone: MotoEntregaIcon, ajuda: "Novo Pedido e Finalizar da retirada" },
  { key: "cardapio", label: "Cardápio Digital", curto: "Cardápio", Icone: Smartphone, ajuda: "O que o cliente escolhe ao pedir pelo link" },
  { key: "whatsapp", label: "WhatsApp", curto: "WhatsApp", Icone: MessageCircle, ajuda: "Formas que a CLEO oferece na conversa" },
];

export const TAXA_VAZIA = { taxa_percentual: "0", taxa_fixa: "0", prazo_dias: "0" };

export const FORM_VAZIO = {
  name: "",
  code: "",
  is_active: true,
  // Comandas (24/10/2026) entra ligada como os outros: sem ela o switch nascia
  // desligado na forma nova, mas o servidor gravava ligada (copia de Mesas).
  visivel: Object.fromEntries(MODULOS.map((m) => [m.key, true])),
  nomes: {},
  emitir_nf_auto: false,
  up_entrega_method: "none",
  up_entrega_return: true,
  taxa: TAXA_VAZIA,
};

const lerNomes = (bruto) => {
  if (!bruto) return {};
  if (typeof bruto === "object") return bruto;
  try { return JSON.parse(bruto) || {}; } catch (_) { return {}; }
};

const bool = (v, padrao) => (v === null || v === undefined ? padrao : v === true || v === 1 || v === "1" || v === "true");

export function formDaForma(pm, taxa) {
  return {
    name: pm.name || "",
    code: pm.code || "",
    is_active: bool(pm.is_active, true),
    visivel: Object.fromEntries(MODULOS.map((m) => [m.key, bool(pm[`visible_${m.key}`], true)])),
    nomes: lerNomes(pm.module_names),
    emitir_nf_auto: bool(pm.emitir_nf_auto, false),
    up_entrega_method: pm.up_entrega_method || "none",
    up_entrega_return: bool(pm.up_entrega_return, true),
    taxa: taxaDoServidor(taxa),
  };
}

export const taxaDoServidor = (t) => (t ? {
  taxa_percentual: String(t.taxa_percentual ?? 0),
  taxa_fixa: String(t.taxa_fixa ?? 0),
  prazo_dias: String(t.prazo_dias ?? 0),
} : TAXA_VAZIA);

export const taxaParaServidor = (t) => ({
  taxa_percentual: Number(t.taxa_percentual) || 0,
  taxa_fixa: Number(t.taxa_fixa) || 0,
  prazo_dias: parseInt(t.prazo_dias, 10) || 0,
});

export const codigoDoNome = (nome) => nome.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")
  .trim().replace(/\s+/g, "_").replace(/[^a-z0-9_]/g, "");

/** Payload de PUT/POST /payment-methods. Na edição o código não vai: ele liga a
 *  forma aos pedidos, às taxas e à nota fiscal já gravados. */
export function payloadDaForma(form, criando) {
  const nomes = Object.fromEntries(Object.entries(form.nomes).filter(([, v]) => v && v.trim()).map(([k, v]) => [k, v.trim()]));
  const payload = {
    name: form.name.trim(),
    is_active: form.is_active,
    emitir_nf_auto: form.emitir_nf_auto,
    module_names: Object.keys(nomes).length ? nomes : null,
    up_entrega_method: form.up_entrega_method === "none" ? null : form.up_entrega_method,
    up_entrega_return: form.up_entrega_method === "none" ? null : form.up_entrega_return,
    ...Object.fromEntries(MODULOS.map((m) => [`visible_${m.key}`, form.visivel[m.key]])),
  };
  if (criando) payload.code = form.code.trim() || codigoDoNome(form.name);
  return payload;
}
